(function () {
  if (!document.documentElement.classList.contains("ab-convert-dual-shell")) {
    return;
  }

  function isVariationB() {
    return document.documentElement.classList.contains("ab-convert-variation-b");
  }

  function syncBodyAndHtmlClasses() {
    var vB = isVariationB();
    var body = document.body;
    var html = document.documentElement;
    if (vB) {
      body.classList.add("ab-home--b", "home-variant--new", "footer-group--new");
      body.classList.remove("footer-group--legacy");
      html.classList.add("ab-nav--b", "ab-home--b", "home-variant--new");
    } else {
      body.classList.remove("ab-home--b", "home-variant--new", "footer-group--new");
      body.classList.add("footer-group--legacy");
      html.classList.remove("ab-nav--b", "ab-home--b", "home-variant--new");
    }
  }

  var lastMobileMainHeaderSlotPx = 0;

  function syncMobileMainHeaderSlotHeight() {
    if (!isVariationB()) {
      return;
    }
    if (!window.matchMedia("(max-width: 991.98px)").matches) {
      document.body.style.removeProperty("--ab-mobile-main-header-slot-height");
      return;
    }
    var root = document.getElementById("ab-shell-new");
    if (!root) {
      return;
    }
    var main = root.querySelector(".shopify-section-main-header");
    var hdr = root.querySelector("header.header");
    if (!main || !hdr) {
      return;
    }
    var sticky = document.body.classList.contains("sticky-header");
    var hdrHidden = hdr.classList.contains("sticky-header-hidden");
    var slotPx;
    if (!sticky) {
      slotPx = Math.ceil(main.getBoundingClientRect().height);
      if (slotPx > 0) {
        lastMobileMainHeaderSlotPx = slotPx;
      }
    } else if (hdrHidden && lastMobileMainHeaderSlotPx > 0) {
      slotPx = lastMobileMainHeaderSlotPx;
    } else {
      var fixedPad = 32;
      var fromFixed = Math.ceil(hdr.getBoundingClientRect().height) + fixedPad;
      slotPx = Math.max(fromFixed, lastMobileMainHeaderSlotPx || 0);
      if (slotPx > 0) {
        lastMobileMainHeaderSlotPx = slotPx;
      }
    }
    if (slotPx > 0) {
      document.body.style.setProperty("--ab-mobile-main-header-slot-height", slotPx + "px");
    }
  }

  function syncFixedHeaderCssVars() {
    if (!isVariationB()) {
      return;
    }
    var root = document.getElementById("ab-shell-new");
    if (!root) {
      return;
    }
    var body = document.body;
    var annEl = root.querySelector(".announcement-bar-section");
    var topPx = 16;
    if (annEl) {
      var rect = annEl.getBoundingClientRect();
      var oh = annEl.offsetHeight;
      var bottom = Math.round(rect.bottom);
      if (oh > 0 && bottom < 8) {
        bottom = Math.round(rect.top + oh);
      }
      if (oh > 0 && bottom < Math.round(oh * 0.75) && window.scrollY < 2) {
        bottom = Math.round(rect.top + oh);
      }
      topPx = Math.max(16, bottom + 16);
    }
    var hdr = root.querySelector("header.header");
    var hdrH = hdr ? hdr.offsetHeight : 0;
    body.style.setProperty("--ab-fixed-header-top", topPx + "px");
    body.style.setProperty("--header-height", hdrH + "px");
    syncMobileMainHeaderSlotHeight();
  }

  var announcementResizeObserved = false;
  function observeAnnouncementResize() {
    if (announcementResizeObserved || typeof ResizeObserver === "undefined") {
      return;
    }
    var root = document.getElementById("ab-shell-new");
    if (!root) {
      return;
    }
    var annEl = root.querySelector(".announcement-bar-section");
    if (!annEl) {
      return;
    }
    announcementResizeObserved = true;
    new ResizeObserver(function () {
      syncFixedHeaderCssVars();
    }).observe(annEl);
  }

  function syncInert() {
    var vB = isVariationB();
    document.querySelectorAll(".ab-shell--legacy").forEach(function (el) {
      if (vB) {
        el.setAttribute("aria-hidden", "true");
        el.setAttribute("inert", "");
      } else {
        el.removeAttribute("aria-hidden");
        el.removeAttribute("inert");
      }
    });
    document.querySelectorAll(".ab-shell--new").forEach(function (el) {
      if (vB) {
        el.removeAttribute("aria-hidden");
        el.removeAttribute("inert");
      } else {
        el.setAttribute("aria-hidden", "true");
        el.setAttribute("inert", "");
      }
    });
  }

  var prevVariationB;
  var layoutRaf = null;

  function scheduleLayoutRefresh() {
    if (layoutRaf != null) {
      return;
    }
    layoutRaf = requestAnimationFrame(function () {
      layoutRaf = null;
      try {
        window.dispatchEvent(new Event("resize"));
        window.dispatchEvent(new Event("scroll"));
        syncFixedHeaderCssVars();
      } catch (e) {}
    });
  }

  function syncIfVariationChanged() {
    var vB = isVariationB();
    if (prevVariationB === vB) {
      return;
    }
    prevVariationB = vB;
    syncBodyAndHtmlClasses();
    syncInert();
    scheduleLayoutRefresh();
  }

  prevVariationB = isVariationB();
  syncBodyAndHtmlClasses();
  syncInert();
  syncFixedHeaderCssVars();
  observeAnnouncementResize();
  scheduleLayoutRefresh();

  requestAnimationFrame(function () {
    requestAnimationFrame(syncFixedHeaderCssVars);
  });

  window.addEventListener("load", syncFixedHeaderCssVars);

  var scrollSyncRaf = null;
  window.addEventListener(
    "scroll",
    function () {
      if (scrollSyncRaf != null) {
        return;
      }
      scrollSyncRaf = requestAnimationFrame(function () {
        scrollSyncRaf = null;
        syncFixedHeaderCssVars();
      });
    },
    { passive: true }
  );
  window.addEventListener("resize", syncFixedHeaderCssVars);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === "class") {
        syncIfVariationChanged();
        if (typeof runPlpStickyFilterSetup === "function") {
          runPlpStickyFilterSetup();
        }
        break;
      }
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

  new MutationObserver(function () {
    syncMobileMainHeaderSlotHeight();
  }).observe(document.body, { attributes: true, attributeFilter: ["class"] });

  var plpFilterIo = null;

  function destroyPlpStickyFilterObserver() {
    if (plpFilterIo) {
      plpFilterIo.disconnect();
      plpFilterIo = null;
    }
    var oldSentinels = document.querySelectorAll("[data-ab-plp-sticky-sentinel]");
    for (var i = 0; i < oldSentinels.length; i++) {
      if (oldSentinels[i].parentNode) {
        oldSentinels[i].parentNode.removeChild(oldSentinels[i]);
      }
    }
    var tbs = document.querySelectorAll(".yv-collections-topbar-sticky[data-ab-plp-topbar-observed]");
    for (var j = 0; j < tbs.length; j++) {
      tbs[j].removeAttribute("data-ab-plp-topbar-observed");
    }
    document.body.classList.remove("ab-plp-sticky-filters-active");
  }

  function syncPlpFilterStuckState(sentinel) {
    if (!sentinel || !document.body.contains(sentinel)) {
      return;
    }
    var rect = sentinel.getBoundingClientRect();
    var stuck = rect.bottom < 0.5;
    document.body.classList.toggle("ab-plp-sticky-filters-active", stuck);
  }

  function setupPlpStickyFilterHeaderToggle() {
    if (!isVariationB()) {
      destroyPlpStickyFilterObserver();
      return;
    }
    if (!window.matchMedia("(max-width: 767.98px)").matches) {
      destroyPlpStickyFilterObserver();
      return;
    }
    var b = document.body;
    if (!b.classList.contains("template_collection") && !b.classList.contains("template_search")) {
      destroyPlpStickyFilterObserver();
      return;
    }
    var topbar = document.querySelector(".yv-collections-topbar-sticky");
    if (!topbar) {
      destroyPlpStickyFilterObserver();
      return;
    }
    var sentinel = document.createElement("div");
    sentinel.setAttribute("data-ab-plp-sticky-sentinel", "");
    sentinel.setAttribute("aria-hidden", "true");
    sentinel.style.width = "1px";
    sentinel.style.height = "1px";
    sentinel.style.margin = "0";
    sentinel.style.padding = "0";
    sentinel.style.border = "0";
    sentinel.style.pointerEvents = "none";
    topbar.parentNode.insertBefore(sentinel, topbar);
    topbar.setAttribute("data-ab-plp-topbar-observed", "1");

    plpFilterIo = new IntersectionObserver(
      function (entries) {
        for (var e = 0; e < entries.length; e++) {
          var entry = entries[e];
          var t = entry.target;
          if (t && t.getAttribute("data-ab-plp-sticky-sentinel") !== null) {
            syncPlpFilterStuckState(t);
            break;
          }
        }
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 1] }
    );
    plpFilterIo.observe(sentinel);
    syncPlpFilterStuckState(sentinel);
  }

  function runPlpStickyFilterSetup() {
    destroyPlpStickyFilterObserver();
    setupPlpStickyFilterHeaderToggle();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runPlpStickyFilterSetup);
  } else {
    runPlpStickyFilterSetup();
  }
  window.addEventListener("load", runPlpStickyFilterSetup);
  window.addEventListener("resize", function () {
    runPlpStickyFilterSetup();
  });
  document.addEventListener("shopify:section:load", function () {
    runPlpStickyFilterSetup();
  });
})();
